import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const therapists = [{
  name: '小雅',
  role: 'Senior Therapist',
  exp: '5 Years Experience',
  rating: 4.9,
  specialty: 'Aromatherapy',
  image: 'https://cdn.magicpatterns.com/uploads/9F2weLuthibUh4uhwkAiM8/4ba86120c650434ca0993a617463c3f8.jpg'
}, {
  name: '美琳',
  role: 'Master Therapist',
  exp: '8 Years Experience',
  rating: 5.0,
  specialty: 'Thai Massage',
  image: 'https://cdn.magicpatterns.com/uploads/fqvqvS8EFuEagWa8sLggBk/da16b3dff67a49a6b18ea87ebc010f5c.jpg'
}, {
  name: '雪儿',
  role: 'Elite Companion',
  exp: '4 Years Experience',
  rating: 4.8,
  specialty: 'Social Events',
  image: 'https://cdn.magicpatterns.com/uploads/mvZ1w85CZ95vh4LLUNirji/a67add7451f04affa3d1c14fd475eb72.jpg'
}, {
  name: '心怡',
  role: 'Wellness Expert',
  exp: '6 Years Experience',
  rating: 4.9,
  specialty: 'Deep Tissue',
  image: 'https://cdn.magicpatterns.com/uploads/99Vhz4DRZjWbNTWSoHFhqp/17687258727114.jpg'
}];
export function TherapistProfiles() {
  return <section id="therapists" className="py-24 bg-white" data-id="element-216">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="text-center mb-16" data-id="element-218">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-219">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-220">
              精英团队
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium" data-id="element-221">
              Our Elite Professionals
            </p>
            <p className="max-w-3xl mx-auto text-gray-600 leading-relaxed mt-6 text-lg" data-id="element-222">
              新加坡幸福缘拥有20余位经验丰富的专业按摩技师，每一位技师均经过严格筛选与系统培训，精通精油按摩、泰式按摩、深层组织按摩、足部按摩等多种专业手法。我们的技师团队来自各地，拥有丰富的按摩经验与专业资质，致力于为新加坡的每一位客户提供最专业、最贴心的按摩服务体验。
            </p>
            <div className="w-24 h-1 bg-[#c9a96e] mx-auto mt-6" data-id="element-223" />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-224">
          {therapists.map((therapist, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative" data-id="element-225">
              <div className="aspect-[3/4] w-full overflow-hidden rounded-sm bg-gray-100 relative mb-4" data-id="element-226">
                {/* Profile Photo */}
                <img src={therapist.image} alt={therapist.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-227" />

                {/* Overlay Content */}
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#1a1a2e]/90 to-transparent pt-12" data-id="element-228">
                  <h3 className="text-2xl font-serif font-bold text-white mb-1" data-id="element-229">
                    {therapist.name}
                  </h3>
                  <p className="text-[#c9a96e] text-sm font-medium uppercase tracking-wider" data-id="element-230">
                    {therapist.role}
                  </p>
                </div>
              </div>

              <div className="bg-[#faf7f2] p-4 rounded-sm border border-gray-100 group-hover:border-[#c9a96e]/30 transition-colors" data-id="element-231">
                <div className="flex justify-between items-center mb-2" data-id="element-232">
                  <span className="text-sm text-gray-600 font-medium" data-id="element-233">
                    {therapist.specialty}
                  </span>
                  <div className="flex items-center text-[#c9a96e]" data-id="element-234">
                    <Star size={14} fill="currentColor" data-id="element-235" />
                    <span className="ml-1 text-sm font-bold" data-id="element-236">
                      {therapist.rating}
                    </span>
                  </div>
                </div>
                <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-237">
                  {therapist.exp}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}